import React from 'react';
import Tour from '../../../../../models/Tour';
import TourListItemSimple from '../../TourListItemSimple';
import TourItemDescription from '../../common/TourItemDescription';

interface TourFourListItemProps {
    tour: Tour;
    showDetails?: boolean;
}

const TourFourListItem: React.FC<TourFourListItemProps> = ({ tour, showDetails = false }) => {
    return (
        <TourListItemSimple tour={tour} showDetails={showDetails}>
            <TourItemDescription tour={tour} />
        </TourListItemSimple>
    )
}

export default TourFourListItem;